import { cx } from "@/lib/tailwind-utils";

/** One segment per unit: filled, then highlighted (critical and still open), then empty. */
export function SegmentedBar({
  filled,
  highlighted = 0,
  total,
  label,
  className,
}: {
  filled: number;
  highlighted?: number;
  total: number;
  /** Accessible description, e.g. "3 of 11 items done". Leave it out inside a button,
   *  where the button's own text should carry the status. */
  label?: string;
  className?: string;
}) {
  return (
    <span
      {...(label
        ? {
            role: "progressbar",
            "aria-valuenow": filled,
            "aria-valuemin": 0,
            "aria-valuemax": total,
            "aria-label": label,
          }
        : { "aria-hidden": true })}
      className={cx("flex gap-0.5", className)}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          className={cx(
            "h-1 flex-1 rounded-full",
            index < filled
              ? "bg-primary"
              : index < filled + highlighted
                ? "bg-destructive/50"
                : "bg-border",
          )}
        />
      ))}
    </span>
  );
}
